<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-button type="primary" size="medium" @click="addButton(0)" v-if="userPermissions.indexOf('buser_create') != -1">添加</el-button>
          </el-col>
        </el-row>
        <el-row class="table-search">
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="姓名">
              <el-input v-model="searchCondition.fullname" placeholder="输入姓名" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="searchCondition.mobile" placeholder="输入手机号" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <ApeTable ref="apeTable" :data="userList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row >
           <el-table-column
            slot="second-column"
            align="left"
            width="150"
            label="ID">
            <template slot-scope="scope">
              <div>
                {{scope.row.id}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="手机号">
            <template slot-scope="scope">
              <div>
                {{scope.row.mobile}}
              </div>
            </template>
          </el-table-column>
           <el-table-column
            slot="second-column"
            align="center"
            label="姓名">
            <template slot-scope="scope">
              <div>
                <el-tooltip class="item" effect="dark" :content="scope.row.id" placement="top">
                <div>{{ scope.row.fullname }}</div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            slot="second-column"
            align="center"
            label="状态">
            <template slot-scope="scope">
              <div>
                {{scope.row.status | UserStatus}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="buttonType=='text'"
            align="center"
            label="操作">
            <template slot-scope="scope">
              <span>
                <el-button size="mini" @click="editButton(scope.row.id)" v-if="userPermissions.indexOf('buser_edit') != -1">编辑</el-button>
                <el-popover
                  v-if="userPermissions.indexOf('buser_delete') != -1"
                  placement="top"
                  width="150"
                  v-model="scope.row.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="scope.row.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">确定</el-button>
                  </div>
                  <el-button slot="reference" type="danger" size="mini" >删除</el-button>
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
    </PageHeaderLayout>

    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="debouncedrawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="formData" :rules="rules" ref="userForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="formData.mobile" @input="event_inputMobile"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="姓名" prop="fullname">
                <el-input v-model="formData.fullname"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="公司绑定" prop="user_company">
              <el-select v-model="formData.user_company" multiple filterable placeholder="请选择" style="width: 100%"
              :filter-method="companyFilter"
              >
                  <el-option
                    v-for="item in companyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </ApeDrawer>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters, mapState } from 'vuex'
// import { delete } from 'vue/types/umd'
import {debounce} from '../../utils/utils.js'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
  },
  data() {
    return {
      userId: '',
      // 搜索条件
      searchCondition:{},
      loadingStaus: true,
      columns: [],
      // 表格列表数据
      userList:[],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        mobile:'',
        fullname:'',
        user_company:[],
      },
      // 表单验证
      rules: {
        mobile: [
          {required: true, message: '输入手机号', trigger: 'blur' },
          { min: 11,max:11, message: '请输入11位手机号' }
        ],
        fullname: [
          {required: true, message: '输入姓名', trigger: 'blur' },
        ],
        user_company: [
          {required: true, message: '请选择公司绑定', trigger: 'blur' },
        ]
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '正在加载中……',
        title: '权限绑定',
        width_height: '480px',
      },
      // 用户绑定角色
      rolesList: [],
      // 所有公司列表
      allCompanyList:[],
      // 用户绑定公司
      companyList: [],
    }
  },
  watch: {
   
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType']),
    ...mapState({
      companyId: state => state.switchInfo.companyId,
    }),
  },
  methods: {
	event_inputMobile(){
		this.formData.mobile = this.formData.mobile.replace(/[^\d]/g,'')
	},
    // 获取已选中的公司
	getChooseCompany(){
		let items = []
		this.formData.user_company?.map(item=>{
			this.allCompanyList.map(item_child=>{
				if(item_child.id == item){
					items.push(item_child)
				}
			})
		})
		return items
	},
    // 过滤公司列表
    companyFilter(query=''){
      let arr = this.allCompanyList.filter((item) => {
        return item.name.includes(query)
      })
      if(arr.length>50){
         arr = arr.slice(0, 50)
      }
      const chosen = this.getChooseCompany()
      let result  = [...arr,...chosen.filter(item => !arr.includes(item))]
      this.companyList = result
    },
      //获取全部公司
    async getCompanyCategoryList() {
      let result = await this.$api.getCompanyCategoryList()
      let result_copy = []
      // for(let i = 0;i<5000;i++){
      //   let obj = {
      //         id:new Date().getTime()+i,
      //         name:'测试公司'+i
      //   }
      //   result_copy.push(obj)
      // }
      let res = result.concat(result_copy)
      if(result) {
        this.allCompanyList = res
        this.companyFilter()
      }
    },
    // 搜索
    searchButton() {
      this.initUserList()
    },
    // 切换页码操作
    async switchPaging() {
      this.initUserList()
    },
    // 响应添加按钮
    async addButton() {
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '添加用户'
      this.userId = '';
      this.formData = {}
      this.getCompanyCategoryList()
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },

    //用户详情
    async viewBuser(id) {
      let result = await this.$api.viewBuser(id)
      if(result) {
        this.drawerData.visible = true
        this.formData = result
      }
    },
    // 响应编辑按钮
    async editButton(id) {
      this.userId = id
      this.drawerData.loading_text = '正在加载中……'
      this.drawerData.loading = false
      this.drawerData.title = '编辑用户(UID：'+id+')'
      this.viewBuser(id)
      this.getCompanyCategoryList()
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.drawerData.visible = false
      this.drawerData.loading = true
      this.rolesList = []
      this.userId = '';
      this.formData = {}
      this.$refs['userForm'].resetFields();
    },
	debouncedrawerConfirm:
			debounce(
			function() {
			this.drawerConfirm()
			},
			2000,
			true
			)
		,
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['userForm'].validate((valid) => {
        if (valid) {
          if(this.userId) {
            this.updateBuser(this.userId, this.formData)
          }else {
            this.createBuser(this.formData)
          }
        } else {
          console.log(this.formData);
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },

    //角色列表
    async getRolesList(){
      let result = await this.$api.getRolesList()
      if(result) {
        this.rolesList = result
      }
    },
    //编辑用户
    async updateBuser(id, data) {
      let result = await this.$api.updateBuser(id, data)
      if(result) {
        this.drawerData.visible = false
        this.$refs['userForm'].resetFields();
        this.initUserList()
      }
    },
    //新增用户
    async createBuser(data) {
      let result = await this.$api.createBuser(data)
      if(result) {
        this.drawerData.visible = false
        this.$refs['userForm'].resetFields();
        this.initUserList()
      }
    },
    // 相应删除按钮
    async deleteButton(id) {
      let result = await this.$api.deleteBuser(id)
      if(result) {
        this.initUserList()
      }
    },
    // 初始化用户列表
    async initUserList(type) {
      this.loadingStaus = true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      let searchCondition = this.searchCondition
      Object.assign(searchCondition,pagingInfo)
      let { data, pages } = await this.$api.getBuserList(searchCondition)
      this.$nextTick(() => {
        this.userList = data
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus = false
    }
  },
  mounted() {
    this.initUserList()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .table-header
    margin-bottom 12px
  .drag-handle
    font-size 24px
    cursor pointer
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .el-select > .el-input
    width 300px
  #generate {
    margin-bottom: -10px;
    margin-left: 4px;
  }
</style>
